import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Location, DatePipe, AsyncPipe } from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {first, switchMap} from 'rxjs/operators';
import {MemberStateService} from '../../../services/member-state.service';
import {FormatService} from '../../../services/format.service';
import {PaymentService} from '../../../services/payment.service';
import {UserContextService} from '../../../services/user-context.service';
import {Observable} from 'rxjs';
import {PaymentMomentDetail} from '../../../model/payment-moment-detail';
import {ViewState, toViewState} from '../../../model/view-state';
import { LoaderComponent } from '../../shared/loader/loader.component';
import { KeyValueComponent } from '../../shared/key-value/key-value.component';
import { AllowancesDetailSummaryComponent } from './allowances-detail-summary/allowances-detail-summary.component';
import { AllowancesDetailCalculationComponent } from './allowances-detail-calculation/allowances-detail-calculation.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'myabvv-allowances-detail-by-payment-date',
    standalone: true,
    templateUrl: './allowances-detail-by-payment-date.component.html',
    imports: [
      LoaderComponent, KeyValueComponent, AllowancesDetailSummaryComponent,
      AllowancesDetailCalculationComponent, DatePipe, TranslatePipe, AsyncPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AllowancesDetailByPaymentDateComponent implements OnInit {
  private location = inject(Location);
  private route = inject(ActivatedRoute);
  private memberStateService = inject(MemberStateService);
  private formatService = inject(FormatService);
  private paymentService = inject(PaymentService);
  private userContext = inject(UserContextService);


  paymentDate: string;
  state$: Observable<ViewState<PaymentMomentDetail[]>>;

  ngOnInit() {
    const isInternalUser = this.userContext.isInternalUser();

    const source$ = this.route.queryParams.pipe(
      first(),
      switchMap(params => {
        this.paymentDate = params['paymentDate'];

        // Use /me endpoint for external users, /{inss} for internal users
        return isInternalUser
          ? this.memberStateService.getMember().pipe(
              first(),
              switchMap(member => this.paymentService.getDetailByPaymentDate(member.personalInformation.inss, this.paymentDate))
            )
          : this.paymentService.getMyDetailByPaymentDate(this.paymentDate);
      })
    );

    this.state$ = source$.pipe(toViewState());
  }

  onGoBackToOverview() {
    this.location.back();
  }

  getTranslatedMonth(dateToFormat: string): string {
    return this.formatService.formatDate(`${dateToFormat}-01`);
  }

}
